<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 跳转路由的判断 -->
        <!-- <van-button type="primary" size="mini" @click="openUrls">跳转路由判断的</van-button> -->
        <!--  -->
        <van-search v-model.trim="keyWord" @input="ReturnResult" @clear='onClear' show-action placeholder="请输入小区名称或地址进行查询" @search="onSearch" @cancel="onCancel" />
        <div v-if="isShow">
            <div class="KeyWordChat" style="border-bottom:1px solid #e0e0e0" v-for="item in list" :key="item"  @click="openQuarters(item)">
                <van-icon name="location" size="25"/>
                <div>
                    <div v-html="item.regionName" style="font-size:14px;margin-left:7px;margin-bottom:5px;margin-top:5px"></div>
                    <div v-html="item.address" style="font-size:13px;color:gray;margin-left:7px;margin-bottom:4px"></div>
                </div>
            </div>
            <!-- 在这加个判断  如果list有东西就显示  如果list没有东西的话就不显示 -->
            <div style="margin-left:7px;font-size:14px;color:gray;margin-top:6px;padding-left:15px" v-if="display">找不到更多匹配结果...</div>
        </div>
        
        <!-- <van-cell-group v-if="isShow">
            <van-cell icon="location-o" v-for="item in list" :key="item" v-html="item.regionName"/>

            <van-cell title="没有更多匹配结果"/>
        </van-cell-group> -->
        <!-- 还没开始搜索的时候显示 -->
        <div style="margin-top:30px" v-if="!isShow">
            <van-empty class="custom-image" image="search" description="请先查询" />
        </div>
        <!--  -->
    </div>
</template>

<script>
    // import axios from 'axios'
    // import qs from 'qs'
    export default {
        data() {
            return {
                display:false,
                isShow:false,
                // keyWord: '', //搜索关键词
                // keyWord:this.$store.state.keyWord,
                keyWord:sessionStorage.getItem('keyWord'), //搜索关键词
                list:[],
                cancel: null,
                source:null,
                timer:'',
                id:'',
            }
        },
        // beforeRouteEnter(to, from, next) {
        //     console.log(to)
        //     console.log(from)
        //     if(from.name=='维修项目列表'){
        //         // this.ReturnResult()

        //         next(true)
        //         this.ReturnResult()
        //     }
        //     else{
        //         next(true)
        //     }
        //     // next()
        // },
        methods: {
            // 
            openUrls(){
                this.$router.replace({
                    path:'PoliciesRegulations'
                })
            },
            // 
            onSearch() {

            },
            onCancel() {
                this.isShow = false
            },
            onClear(){
                this.isShow = false
            },
            /**
             * 触发事件
             */
            ReturnResult(){
                console.log(this.keyWord)
                this.clearTimer()
                //ajax
                if(this.keyWord&&this.keyWord.length>0){
                    this.timer = setTimeout(() => {
                        let keyWord = this.keyWord
                        console.log(keyWord)
                    }, 1000);
                    this.isShow = true
                    //发送ajax
                    let data={
                        keyWord:this.keyWord,
                        // keyWord:this.$store.state.keyWord,
                        pageNum:1,
                        pageSize:10
                    }
                    this.$nextTick(()=>{
                        // 这一步注释了  没注释之前这步是当返回搜索的时候搜索的下一级删除的时候结束上一步的搜索  为了避免造成代码请求顺序错乱
                        // var that = this;
                        // var CancelToken = axios.CancelToken
                        // var source = CancelToken.source()
                        // console.log(source,'qqqqqqqqqqqqqqqqq')
                        // this.cancelRequest();
                        // axios.post('http://192.168.31.22:8033/WeChat/getRegionListByKeyWord',qs.stringify(data),{
                        //     headers: {
                        //         // 'Content-Type': 'application/x-www-form-urlencoded',
                        //         'Content-Type': 'application/x-www-form-urlencoded',
                        //         'Accept': 'application/json'
                        //     },
                        //     cancelToken: new axios.CancelToken(function executor(c) {
                        //         that.source = c;
                        //     })
                        // })
                        this.$postQuery('/WeChat/getRegionListByKeyWord',data)
                        .then((response) => {
                            console.log(response,'111111111111111111111')
                            if(response.code==200){
                                this.list = response.data.list
                                // 新加的
                                if(this.list.length==0){
                                    this.display = true
                                }else{
                                    this.display = false
                                }
                                // 
                                this.list = this.list.filter((item)=>{
                                const reg = new RegExp(this.keyWord,'g')//不区分大小写处理
                                const replaceString = '<span style="color:#e1251b">'+this.keyWord+'</span>'
                                if(item.regionName.match(reg)||item.address.match(reg)){
                                    item.regionName = item.regionName.replace(reg,replaceString)//如果regionName和address有一个符合的就把符合的那个的字段变成红色的
                                    item.address = item.address.replace(reg,replaceString)
                                    return item
                                    }
                                })
                            }
                        })
                    })
                }else if(this.keyWord.trim()==''){
                    this.isShow = false
                }
                
            },
            clearTimer() {
                if (this.timer) {
                    clearTimeout(this.timer);
                }
            },
            /**
             * 取消上一次请求
             */
            // cancelRequest(){
            //     if(typeof this.source ==='function'){
            //         this.source('终止请求')
            //     }
            // },
            /**
             * 
             */
            openQuarters(item){
                // 在这里存一下数据  否则页面返回时输入的数据消失
                sessionStorage.setItem('keyWord',this.keyWord)
                // this.ReturnResult()
                // console.log({...item},'1111111')
                // console.log(item.regionName,'2222222222')
                
                this.$router.push({
                    path:'/ProjectList',
                    query:{
                        id:item.id,
                        // regionName:item.regionName
                    }
                })
            }
        },
        created(){
            // this.$nextTick(()=>{
            this.ReturnResult()

            // })
        }
        
    }
</script>

<style scoped>
.list {
    margin-top: 46px;
}
.custom-image>>>.van-empty__image {
    width: 150px;
    height: 150px;
}
.KeyWordChat{
    display: flex;
    align-items: center;
    padding-left: 15px;
}
</style>